import { useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '_store';

export function ProtectedRoute({ children, requiredRoles }) {
    const { userRole } = useContext(AuthContext);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Simulate loading user role from context or local storage
        const loadUserRole = async () => {
            // Simulate an async operation to load user role
            await new Promise(resolve => setTimeout(resolve, 100));
            setIsLoading(false);
        };

        loadUserRole();
    }, []);

    if (isLoading) {
        return <div></div>;
    }

    // Ensure userRole is defined and is an array
    if (!userRole) {
        return <Navigate to="/no-permission" />;
    }

    const hasRequiredRole = requiredRoles.some(role => userRole.includes(role));

    if (!hasRequiredRole) {
        return <Navigate to="/no-permission" />;
    }

    return children;
}
